import _extends from "../../node_modules/@babel/runtime/helpers/esm/extends.es.js";
const getPickersLocalization = (pickersTranslations) => {
  return {
    components: {
      MuiLocalizationProvider: {
        defaultProps: {
          localeText: _extends({}, pickersTranslations)
        }
      }
    }
  };
};
export {
  getPickersLocalization
};
//# sourceMappingURL=getPickersLocalization.es.js.map
